// Libs
import React, { Component } from 'react'
import { Row, Col } from '../../components/Elemental'
import { connect } from 'react-redux'
import Papa from 'papaparse'
import _ from 'lodash'

// CSS
import './styles.scss'

// Components/Containers
import Breadcrumb from '../../components/Breadcrumb'
import Button from '../../components/Button'

// Actions
import { changeImporterSelectedFile, changeImporterCases, changeImporterStatus, changeImporterSummary } from './actions'

// Constants
import { asyncForEach, sleep, changeCases, convertArrayToObject } from './contants'

// Normalize
import * as normalize from './normalize'
import { capitalize, currency, phone } from '../../constants/normalize'

// Other
import { exportAsXls } from '../../constants/others'

// Validate
import * as validate from './validate'

// Axios
import { serverAPI } from '../../index'

class ImporterLawyer extends Component {
  uploadCases = (file) => {
    const { summary, changeImporterSelectedFile, changeImporterCases, changeImporterSummary } = this.props

    let data = []
    let count = 0

    changeImporterSelectedFile(file.name)

    Papa.parse(file, {
      skipEmptyLines: true,
      encoding: "UTF-8",
      step: (results, parser) => {
        let fields = [{ value: '', error: '' }]
        let lawsuitNumberTag = ''
        let clientNameTag = ''
        let maxValueTag = ''
        let obligationTag = ''

        results.data[0].map((item, index) => {
          let value = item.trim()

          if ([2].indexOf(index) > -1) value = normalize.oabNumber(item)
          if ([5, 6, 7].indexOf(index) > -1) value = phone(item)

          fields = [...fields, { value, error: '' }]
        })

        if (count !== 0) data = [...data, fields]

        count++
      },
      complete: () => {
        if (!_.isEmpty(data)) {
          changeImporterCases(data)
          changeImporterSummary({ ...summary, total: data.length })
        }
      }
    })
  }

  importCases = async () => {
    const { headers, cases, summary, changeImporterCases, changeImporterStatus, changeImporterSummary, importImporterCase } = this.props

    changeImporterStatus('importing')

    let myCases = [...cases]
    let mySummary = { ...summary }
    let fieldsIndex = 0

    for (let fields of myCases) {
      const startTime = new Date().getTime()

      myCases = changeCases(myCases, fieldsIndex, 'value', 'Importando')

      changeImporterCases(myCases)

      let fieldIndex = 0
      let hasError = false

      for (let field of fields) {
        const value = field.value

        // Validate fields
        if ([1, 2, 3, 4].indexOf(fieldIndex) > -1 && !value) {
          myCases[fieldsIndex][fieldIndex].error = `"${headers[fieldIndex].label}" é obrigatório.`
          hasError = true
        }

        const nextValue = fields[fieldIndex + 1] ? fields[fieldIndex + 1].value : ''
        if (fieldIndex === 5 && !value && !nextValue) {
          const msg = "Deve haver ao menos um E-mail ou um Telefone."
          myCases[fieldsIndex][fieldIndex].error = msg
          myCases[fieldsIndex][fieldIndex + 1].error = msg
          hasError = true
        }


        if ([3].indexOf(fieldIndex) > -1 && value.length > 6) {
          myCases[fieldsIndex][fieldIndex].error = `"${headers[fieldIndex].label}" possui mais de 6 caracteres.`
          hasError = true
        }

        if ([4].indexOf(fieldIndex) > -1 && !validate.uf(value)) {
          myCases[fieldsIndex][fieldIndex].error = `"${headers[fieldIndex].label}" não possui uf valida.`
          hasError = true
        }

        fieldIndex++
      }

      // Import case
      if (!hasError) {
        try {
          const data = convertArrayToObject(headers, [myCases[fieldsIndex]], 'value')

          await serverAPI.post('user/data-enrichment', {
            ...data[0]
          })

          myCases = changeCases(myCases, fieldsIndex, 'value', 'Importado')
          mySummary = { ...mySummary, imported: mySummary.imported + 1 }
        } catch (e) {
          console.log(e)
          if (!e.response) myCases[fieldsIndex][1].error = 'Erro ao criar advogado'
          else
            switch (e.response.status) {
              case 404:
                myCases[fieldsIndex][1].error = 'Erro ao criar advogado'
                break;
              default:
                myCases[fieldsIndex][0].error = e.response.data
            }

          hasError = true
        }
      }

      if (hasError) {
        myCases = changeCases(myCases, fieldsIndex, 'value', 'Erro')
        mySummary = { ...mySummary, errors: mySummary.errors + 1 }
      }

      fieldsIndex++

      changeImporterCases(myCases)

      const endTime = new Date().getTime()
      const time = endTime - startTime
      const done = mySummary.imported + mySummary.errors
      const left = mySummary.total - done
      const averageTime = ((mySummary.averageTime * (done - 1)) + time) / done

      mySummary = {
        ...mySummary,
        averageTime,
        timeLeft: averageTime * left
      }

      changeImporterSummary(mySummary)
    }

    changeImporterStatus('imported')
  }

  exportCases = () => {
    const { headers, cases } = this.props

    const data = convertArrayToObject(headers, cases)

    exportAsXls(data, 'Importação', 'Importação')
  }

  handleScroll = e => {
    const bodyWrapper = e.target

    this.refs.header.scrollLeft = bodyWrapper.scrollLeft
  }

  render() {
    const { selectedFile, headers, cases, status, summary, changeImporterSelectedFile } = this.props
    const { uploadCases, importCases, exportCases, handleScroll } = this

    return (
      <div className="importer-lawyer">
        <Breadcrumb routes={['Importador de Contatos']} />
        {/* Rethink this input for client version */}
        <div className="importer-lawyer__question">
          <p>Qual o arquivo que deseja importar?</p>
          <label>
            {selectedFile ? selectedFile : 'Escolha o arquivo'}
            <input
              type="file"
              hidden
              accept=".csv"
              onChange={e => uploadCases(e.target.files[0])} />
          </label>
        </div>
        <div className="importer-lawyer__table">
          <div className="importer-lawyer__summary">
            <ul>
              <li>Total<span>{summary.total}</span></li>
              <li>Importados<span>{summary.imported}</span></li>
              <li>Erros<span>{summary.errors}</span></li>
              <li>Tempo Restante<span>{Math.round(summary.timeLeft / 60000)} MIN</span></li>
            </ul>
          </div>
          <div ref="header" className="importer-lawyer__header">
            <div className="importer-lawyer__row">
              {headers.map(({ value, label, optional }) => (
                <div className="importer-lawyer__field" key={value}>
                  <p>{label}</p>
                  {optional &&
                    <span>(opcional)</span>
                  }
                </div>
              ))}
            </div>
          </div>
          <div
            ref="bodyWrapper"
            className="importer-lawyer__body-wrapper"
            onScroll={handleScroll}>
            <div className="importer-lawyer__body">
              {!_.isEmpty(cases) && cases.map((fields, index) => (
                <div key={index} className="importer-lawyer__row">
                  {fields.map(({ value, error }, index) => {
                    if (value === undefined) {
                      console.log(index, error, value, fields)
                    }
                    return (
                      <div
                        className={error ? "importer-lawyer__field importer-lawyer__field--error" : "importer-lawyer__field"}
                        key={index}>
                        <p>{value}</p>
                        {!error && value.length > 30 &&
                          <div className={`importer-lawyer__modal importer-lawyer__modal--${index + 1 === fields.length ? 'last' : index}`}>
                            <span></span>
                            <div>
                              <p>TEXTO COMPLETO</p>
                              <p>{value}</p>
                            </div>
                          </div>
                        }
                        {error &&
                          <div className={`importer-lawyer__modal importer-lawyer__modal--${index + 1 === fields.length ? 'last' : index} importer-lawyer__modal--error`}>
                            <span></span>
                            <div>
                              <p>PROBLEMA</p>
                              <p>{error}</p>
                            </div>
                          </div>
                        }
                      </div>
                    )
                  })}
                </div>
              ))}
              {_.isEmpty(cases) &&
                <div className="importer-lawyer__row">
                  {headers.map(header => (
                    <div className="importer-lawyer__field" key={header.value} />
                  ))}
                </div>
              }
            </div>
          </div>
        </div>
        <Row>
          <Col sm="100%" md="50%" lg="25%">
            <Button
              type="submit"
              gutterTop={40}
              disabled={_.isEmpty(cases) || status === 'importing' ? true : false}
              onClick={status === 'imported' ? exportCases : importCases}>
              {status === 'imported' ? 'Exportar' : 'Importar'}
            </Button>
          </Col>
        </Row>
      </div>
    )
  }
}

ImporterLawyer = connect(state => ({
  user: state.auth.user,
  selectedFile: state.importerLawyer.selectedFile,
  headers: state.importerLawyer.headers,
  cases: state.importerLawyer.cases,
  status: state.importerLawyer.status,
  summary: state.importerLawyer.summary
}), { changeImporterSelectedFile, changeImporterCases, changeImporterStatus, changeImporterSummary })(ImporterLawyer)

export default ImporterLawyer
